export const Roles = { developer: 'developer', admin: 'admin', leader: 'leader', player: 'player' }
export const defaultErrorMessage = 'An unexpected error has occurred'
export const timeSlots = ['SAT 01', 'SAT 11', 'SAT 19', 'SUN 01', 'SUN 11', 'SUN 19']
export const kvkTypes = ['mee', 'gee', 'dde', 'pce']
export const unitTypes = ['swordsmen', 'pikemen', 'cavalry', 'archers']
export const troopTiersPower = [1, 1, 1.3, 1.7, 2.2, 2.9, 4.2, 6, 8.6, 12.5]
export const minutes = 60 * 1000
export const hours = 60 * minutes
export const days = 24 * hours
export const medalsGroups = [
    { from: 1, to: 1, medals: 100, targets: { from: 20, to: 21 } },
    { from: 2, to: 2, medals: 80, targets: { from: 19, to: 20 } },
    { from: 3, to: 3, medals: 60, targets: { from: 18, to: 19 } },
    { from: 4, to: 4, medals: 40, targets: { from: 17, to: 18 } },
    { from: 5, to: 5, medals: 30, targets: { from: 16, to: 17 } },
    { from: 6, to: 7, medals: 20, targets: { from: 15, to: 16 } },
    { from: 8, to: 10, medals: 15, targets: { from: 14, to: 15 } },
    { from: 11, to: 15, medals: 12, targets: { from: 13, to: 14 } },
    { from: 16, to: 25, medals: 10, targets: { from: 12, to: 13 } },
    { from: 26, to: 50, medals: 5, targets: { from: 11, to: 12 } },
]